import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, Analytics } from 'firebase/analytics';
import { getPerformance } from 'firebase/performance';

// Your Firebase configuration
// Replace these values with your actual Firebase project configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
};

// Debug: Log configuration (remove in production)
console.log('Firebase Config:', {
  hasApiKey: !!firebaseConfig.apiKey,
  hasProjectId: !!firebaseConfig.projectId,
  hasAuthDomain: !!firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId
});

// Check if we have the minimum required configuration
if (!firebaseConfig.projectId || !firebaseConfig.apiKey) {
  console.warn('Firebase configuration is incomplete. Analytics will be disabled.');
  console.warn('Missing:', {
    projectId: !firebaseConfig.projectId,
    apiKey: !firebaseConfig.apiKey
  });
}

// Initialize Firebase only if we have the required configuration
let app: any = null;
let analytics: Analytics | null = null;
let performance: any = null;

if (firebaseConfig.projectId && firebaseConfig.apiKey) {
  try {
    app = initializeApp(firebaseConfig);
    
    // Initialize Analytics (only if supported)
    isSupported().then((supported) => {
      if (supported && app) {
        analytics = getAnalytics(app);
        console.log('Firebase Analytics initialized successfully');
      }
    });

    // Initialize Performance Monitoring
    performance = getPerformance(app);
    console.log('Firebase Performance Monitoring initialized');
  } catch (error) {
    console.error('Failed to initialize Firebase:', error);
  }
} else {
  console.warn('Firebase not initialized - missing required configuration');
}

export { app, analytics, performance };
